import {
  Transfer,
  TransferStatus,
  V2ATransfer,
  V2ATransferStatus,
} from '@varo/graphql-schema-types';
import { TagType } from 'shared/components/vxl/Tag/Tag';
import { formatDisplayDateByMonthYear } from 'shared/utils/string/date';

export const getLast4Digits = (input: string): string => {
  input = '' + (input || '');
  return input.substr(Math.max(input.length - 4, 0));
};

export const transferStatusTagMap: { [index: string]: TagType } = {
  SENT: TagType.INFO,
  IN_PROGRESS: TagType.WARNING,
  CANCELLED: TagType.ERROR,
  CANCELED: TagType.ERROR,
  COMPLETED: TagType.SUCCESS,
  PENDING: TagType.INFO,
  EXPIRED: TagType.INFO,
  HOLD: TagType.WARNING,
};

export const transferStatusTag = (transferStatus: string): TagType =>
  transferStatusTagMap[transferStatus];

export const transactionStatus = [
  V2ATransferStatus.Pending.toLocaleLowerCase(),
  TransferStatus.InProgress.toLocaleLowerCase(),
];

export const groupTransactionsByMonth = (
  transactions: (Transfer | V2ATransfer)[],
  pendingStatus: string,
) => {
  const groupedTransactions: { [key: string]: (Transfer | V2ATransfer)[] } = {};
  transactions.forEach((transaction: Transfer | V2ATransfer) => {
    const createdDate = transaction.createdAt as string;
    const date = new Date(createdDate);
    const yearMonth = `${formatDisplayDateByMonthYear(date)}`;
    const status = transactionStatus.includes(
      transaction?.status.toLocaleLowerCase(),
    )
      ? pendingStatus
      : transaction?.status.toLocaleLowerCase();
    if (!transactionStatus.includes(transaction.status.toLocaleLowerCase())) {
      if (!groupedTransactions[yearMonth]) {
        groupedTransactions[yearMonth] = [];
      }
      groupedTransactions[yearMonth as string].push(transaction);
    } else if (
      transactionStatus.includes(transaction?.status.toLocaleLowerCase())
    ) {
      if (!groupedTransactions[status.toLocaleLowerCase()]) {
        groupedTransactions[status.toLocaleLowerCase()] = [];
      }
      groupedTransactions[status.toLocaleLowerCase() as string].push(
        transaction,
      );
    }
  });

  const groupList = Object.entries(groupedTransactions)
    .map(([key, data]) => ({ title: key, data }))
    .sort((a, b) => {
      const aInStatus = transactionStatus.includes(a.title.toLowerCase());
      const bInStatus = transactionStatus.includes(b.title.toLowerCase());

      if (aInStatus && !bInStatus) {
        return -1;
      }
      if (!aInStatus && bInStatus) {
        return 1;
      }
      return 0;
    });

  return groupList;
};
